import { useTimelineStore } from '../../stores/timelineStore';
import { SidebarGroupItem } from './SidebarGroupItem';
import { CollapsibleSection } from './CollapsibleSection';

export function SidebarGroupsSection() {
  const groups = useTimelineStore((state) => state.groups);

  return (
    <CollapsibleSection
      title="Groups"
      count={groups.length}
      testId="sidebar-groups-section"
    >
      {groups.length === 0 ? (
        <div
          className="text-xs py-3 text-center"
          style={{ color: 'var(--color-dark-text-muted)' }}
        >
          No groups yet
        </div>
      ) : (
        <div className="space-y-0">
          {groups.map((group) => (
            <SidebarGroupItem key={group.id} group={group} />
          ))}
        </div>
      )}
    </CollapsibleSection>
  );
}
